import ExcludedMarkersNotice from './ExcludedMarkersNotice'

export default function HealthScoreCard({ score, bloodTestId = null, excludedCount = 0, contextCheckStatus = null }) {
  if (score === null || score === undefined) {
    return (
      <div className="card">
        <div className="card-body">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">Health Score</h3>
          <p className="text-gray-500 text-sm">Not yet analyzed</p>
        </div>
      </div>
    )
  }

  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success-600'
    if (score >= 60) return 'text-warning-600'
    return 'text-danger-600'
  }

  const getScoreDescription = (score) => {
    if (score >= 80) return 'Excellent'
    if (score >= 60) return 'Good'
    if (score >= 40) return 'Fair'
    return 'Needs Attention'
  }

  const getProgressColor = (score) => {
    if (score >= 80) return 'bg-success-600'
    if (score >= 60) return 'bg-warning-600'
    return 'bg-danger-600'
  }

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="text-lg font-semibold text-gray-700 mb-4">Health Score</h3>

        <div className="flex items-center justify-center mb-4">
          <div className={`text-5xl font-bold ${getScoreColor(score)}`}>
            {Math.round(score)}
          </div>
          <div className="text-2xl text-gray-400 ml-1">/100</div>
        </div>

        <div className="w-full bg-gray-200 rounded-full h-3 mb-2">
          <div
            className={`h-3 rounded-full transition-all duration-500 ${getProgressColor(score)}`}
            style={{ width: `${score}%` }}
          ></div>
        </div>

        <p className={`text-center text-sm font-medium ${getScoreColor(score)}`}>
          {getScoreDescription(score)}
        </p>

        {/* VH-221: markers the score left out, with a link to the list */}
        {bloodTestId && (
          <ExcludedMarkersNotice
            bloodTestId={bloodTestId}
            excludedCount={excludedCount}
            contextCheckStatus={contextCheckStatus}
          />
        )}
      </div>
    </div>
  )
}
